/** The featured list shown on the homepage map for everyone. Swap the id to change the headliner. */
export const HEADLINER_LIST_ID = "a5d43c97-28ec-4c23-b51f-c482e7b3592e"; // "Portland 17"
